/**
 * Constants definition.
 *
 * @type {{NEW_CONTRACT: string, RECONTRACT: string, PROCEDURE_DATA_UPDATE: string}}
 */
const RESIDENTIAL_PROCEDURE_TYPE = {
  NEW_CONTRACT: 'NEW_CONTRACT',
  RECONTRACT: 'RECONTRACT',
  PROCEDURE_DATA_UPDATE: 'PROCEDURE_DATA_UPDATE',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const RESIDENTIAL_PROCEDURE_TYPE_ENUM = Object.keys(RESIDENTIAL_PROCEDURE_TYPE);

const NEW_CONTRACT = RESIDENTIAL_PROCEDURE_TYPE_ENUM[0];
const RECONTRACT = RESIDENTIAL_PROCEDURE_TYPE_ENUM[1];
const PROCEDURE_DATA_UPDATE = RESIDENTIAL_PROCEDURE_TYPE_ENUM[2];

export {
  RESIDENTIAL_PROCEDURE_TYPE,
  RECONTRACT,
  NEW_CONTRACT,
  PROCEDURE_DATA_UPDATE,
  RESIDENTIAL_PROCEDURE_TYPE_ENUM,
};
